// store/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/users`;

export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async ({ email, password }, thunkAPI) => {
    try {
      const response = await axios.post(`${BASE_URL}/login/`, {
        username: email,
        password,
      });
      const { access, refresh, school, role, ui_preferences, user, is_superuser } = response.data;
      localStorage.setItem('accessToken', access);
        localStorage.setItem('refreshToken', refresh);
        localStorage.setItem('role', role || '');
        localStorage.setItem('isSuperuser', String(!!is_superuser));
        if (school) {
          localStorage.setItem('schoolInfo', JSON.stringify({...school, logo: `${school.logo}` || ''}));
        } else {
          localStorage.removeItem('schoolInfo');
        }
        localStorage.setItem('uiPreferences', JSON.stringify(ui_preferences || null));
        // Store user info including is_responsible_teacher
        if (user) {
          localStorage.setItem('user', JSON.stringify(user));
          if (user.is_responsible_teacher !== undefined) {
            localStorage.setItem('isResponsibleTeacher', String(user.is_responsible_teacher));
          }
        }

      return { access, is_superuser: !!is_superuser };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Login failed');
    }
  }
);

export const logoutUser = createAsyncThunk('auth/logoutUser', async () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('isSuperuser');
  return true;
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    accessToken: localStorage.getItem('accessToken') || null,
    isAuthenticated: !!localStorage.getItem('accessToken'),
    isSuperuser: localStorage.getItem('isSuperuser') === 'true',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.accessToken = action.payload.access;
        state.isAuthenticated = true;
        state.isSuperuser = action.payload.is_superuser;
        state.loading = false;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.accessToken = null;
        state.isAuthenticated = false;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.accessToken = null;
        state.isAuthenticated = false;
        state.isSuperuser = false;
      });
  }
});

export default authSlice.reducer;
